/**
 *  All api related to coupon usage
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCouponUsages(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCouponUsages',
    () => source.cancel('fetchCouponUsages: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'coupon_usages',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      couponUsages: _.get(data, 'couponUsages', {}),
      next: _.get(data, 'couponUsagesPagination.nextPage') > page
        ? () =>
          fetchCouponUsages({
            page: page + 1,
            ...others
          })
        : null,
      count: _.get(data, 'couponUsagesPagination.totalCount')
    }))
}

export function fetchCouponUsage({ id, ...params }) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCouponUsage',
    () => source.cancel('fetchCouponUsage: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `coupon_usages/${id}`,
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      couponUsage: _.get(data, 'couponUsage', {})
    }))
}

export function createCouponUsage({ couponTokenQrCode }) {
  const source = CancelToken.source()
  cancelRequest.add(
    'createCouponUsage',
    () => source.cancel('createCouponUsage: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `coupon_usages`,
      method: 'post',
      data: {
        data: {
          couponUsage: {
            couponTokenQrCode,
            source: 'ecom',
          }
        }
      },
      // params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      couponUsage: _.get(data, 'couponUsage', {})
    }))
}
